import CryptoJS from 'crypto-js';
import moment from 'moment-timezone';

const defaultSecretKey = 'qqf5OWTBDimHc3Kx';
const BEIJING_TZ = 'Asia/Shanghai';

function getClientBrand() {
	if (typeof navigator === 'undefined') {
		return '';
	}
	const ua = navigator.userAgent || '';
	let os = '';
	if (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
		os = 'Ios';
	} else if (/Android/i.test(ua)) {
		os = 'Android';
	} else if (/Win/i.test(ua)) {
		os = 'Windows';
	} else if (/Mac/i.test(ua)) {
		os = 'Mac';
	}
	let browser = 'Browser';
	if (/Edg\//i.test(ua)) {
		browser = 'Edge';
	} else if (/OPR\/|Opera/i.test(ua)) {
		browser = 'Opera';
	} else if (/Chrome\//i.test(ua)) {
		browser = 'Chrome';
	} else if (/Firefox\//i.test(ua)) {
		browser = 'Firefox';
	} else if (/Safari\//i.test(ua)) {
		browser = 'Safari';
	}
	return os ? `${os} ${browser}` : browser;
}

const brand = getClientBrand();

/**
 * 使用 moment 获取当前时区与北京时区的时间戳差值（毫秒）
 * 返回值 = 北京时区相对 UTC 的偏移 - 当前时区相对 UTC 的偏移
 * 即：当前本地时间(ms) + 返回值 = 与“北京时间钟表时刻”对齐的等效时间
 * @returns {number} 毫秒数，正数表示北京在当前时区东侧（比当前时区晚）
 */
export function getTimezoneOffsetDiffMs() {
	const localOffsetMinutes = moment().utcOffset();
	const beijingOffsetMinutes = moment.tz(BEIJING_TZ).utcOffset();
	const diffMinutes = beijingOffsetMinutes - localOffsetMinutes;
	return diffMinutes * 60 * 1000;
}

/**
 * 生成 HMAC-SHA256 签名
 * @param {string} data
 * @param {string} key
 * @returns Base64字符串
 */
export function generateHMAC(data, key) {
	const hash = CryptoJS.HmacSHA256(data, key);
	return CryptoJS.enc.Base64.stringify(hash);
}

/**
 * 生成 API 请求签名头
 * @param {string} [secretKey] 密钥，默认 qqf5OWTBDimHc3Kx
 * @returns {{ 'X-Timestamp': string, 'X-Nonce': string, 'X-Signature': string, 'X-Brand': string }}
 */
export function generateApiSignatureHeaders(secretKey = defaultSecretKey) {
	const timestamp = Date.now() + getTimezoneOffsetDiffMs();
	const nonce = Math.random().toString(36).slice(2) + Date.now().toString(36);
	const data = timestamp + nonce;
	const signature = generateHMAC(data, secretKey);
	return {
		'X-Timestamp': timestamp,
		'X-Nonce': nonce,
		'X-Signature': signature,
		'Brand': brand
	};
}
